import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

// "Organization code passed" is asked once per device, ever. Native keeps it in
// Capacitor Preferences (UserDefaults / SharedPreferences), which survives the
// WebView dropping localStorage and the "Clear cache" button. Web keeps it in
// localStorage. Never clear it on sign-out.
const KEY = 'org_code_verified';

/**
 * Synchronous best guess for the first render. true only when the flag is
 * already in localStorage; null means "still loading, do not show the gate".
 */
export const peekOrgCodeVerified = () =>
  localStorage.getItem(KEY) === 'true' ? true : null;

export const loadOrgCodeVerified = async () => {
  const legacy = localStorage.getItem(KEY) === 'true';

  if (!Capacitor.isNativePlatform()) return legacy;

  try {
    const { value } = await Preferences.get({ key: KEY });
    if (value === 'true') return true;
    if (legacy) {
      // Move the old localStorage flag into Preferences
      await Preferences.set({ key: KEY, value: 'true' });
      return true;
    }
    return false;
  } catch (err) {
    console.error('Error reading org code flag:', err);
    return legacy;
  }
};

export const saveOrgCodeVerified = async () => {
  localStorage.setItem(KEY, 'true');
  if (!Capacitor.isNativePlatform()) return;

  try {
    await Preferences.set({ key: KEY, value: 'true' });
  } catch (err) {
    console.error('Error saving org code flag:', err);
  }
};

/** For code that wipes localStorage: read before, restore after. */
export const preserveOrgCodeFlag = (wipe) => {
  const passed = localStorage.getItem(KEY) === 'true';
  wipe();
  if (passed) localStorage.setItem(KEY, 'true');
};
